import { defineMeta } from '@/registry/types';

export const iconMeta = defineMeta({
  name: 'Icon',
  level: 'atom',
  category: 'data-display',
  classification: 'mui-wrapper',
  description: 'Wrapper over MUI SvgIcon that applies semantic icon-color tokens via `tone`.',
  baseLibrary: '@mui/icons-material',
  muiEquivalent: 'SvgIcon',
  muiDocs: 'https://mui.com/material-ui/icons/',
  a2uiEquivalent: 'Icon',
  importPath: '@/atoms/Icon',
  requiredProps: ['icon'],
  optionalProps: ['tone', 'fontSize', 'sx'],
  props: [
    { name: 'icon', type: 'ComponentType<SvgIconProps>', required: true, description: 'Icon component, e.g. from @mui/icons-material' },
    { name: 'tone', type: 'IconTone', description: 'Semantic color token' },
    { name: 'fontSize', type: "'small' | 'medium' | 'large' | 'inherit'" },
  ],
  supportedStates: ['default', 'toned'],
  designTokens: ['icon-colors'],
  accessibility: [
    'Icons are decorative by default; provide titleAccess for meaningful icons.',
    'Do not convey state via color alone.',
  ],
  usageExamples: ['<Icon icon={WarningIcon} tone="warning" />'],
  antiPatterns: ['Do not hardcode hex colors; use the tone prop.'],
  llmSafe: true,
  whenToUse: ['Status indicators, decorative glyphs, button icons'],
  whenNotToUse: ['User identity (use Avatar)'],
});

export default iconMeta;
